import { Flex, ScrollArea, Text } from "@radix-ui/themes";
import React from "react";
import { TbCircleFilled } from "react-icons/tb";
import { NavLink } from "react-router-dom";
import { colors } from "../../../../enums/colors";
import { Separator } from "../../../../ui/Separator";

type Props = {};

const TrackingMenu = (props: Props) => {
  return (
    <>
      <Flex direction="column">
        <Flex direction="row" className="h-12 items-center pr-4">
          <div className="flex flex-none w-8 h-8 items-center justify-center">
            <TbCircleFilled size={12} color={colors.tracking}/>
          </div>
          <Text className="text-base font-semibold">Трэкинг</Text>
        </Flex>
      </Flex>
      <ScrollArea type="hover" scrollbars="vertical">
        <Flex direction="column" px="2">
            <NavLink
                to="/"
                className={({ isActive, isPending }) =>
                    isPending ? "bg-blueA3 flex items-center px-2 py-1 rounded" : 
                    isActive ? "flex items-center px-2 py-1 bg-blueA5 hover:bg-blueA3 rounded" : 
                    "flex items-center px-2 py-1 hover:bg-blueA3 rounded"
                }
                >
                <Text className="text-base font-medium">Календарь перемещений</Text>
            </NavLink>
        </Flex>
        <Flex px="4" py="2">
            <Separator />
        </Flex>
        </ScrollArea>
    </>
  );
};

export default TrackingMenu;
